import { PhoneNumberUtil } from "google-libphonenumber";
import * as yup from "yup";
const phoneUtil = PhoneNumberUtil.getInstance();

let createTicketValidationForm = yup.object().shape({
  queue: yup.string().required("Subject is required"),
  priority: yup.string().required("Priority is required"),
  description: yup.string().required("Description is required"),
});
let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required("Remarks is required"),
});

const AddContactForm = yup.object().shape({
  full_name: yup.string().required("Full Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  phone_number: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
  dob: yup.string().optional().nullable(),
  group: yup.string().required("Group is required"),
});

let AddContactGroupForm = yup.object().shape({
  name: yup.string().required("Group name is required"),
});

const QuickEmailForm = yup.object().shape({
  recipient: yup.string().required("Recipient is required"),
  sender: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  subject: yup.string().required("Subject is required"),
  content: yup.string().required("Message is required"),
});

const QuickSmsForm = yup.object().shape({
  recipient: yup.string().required("Phone number is required"),
  name: yup.string().required("Sender is required"),
  content: yup.string().max(150).required("Message is required"),
});

export const AddEmailGroupForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  // contact: yup.string().required("conatct is required"),
});

const AddEmailCampaign = yup.object().shape({
  name: yup.string().required("Campaign name is required"),
  recipient: yup
    .array()
    .of(yup.string().email("Invalid email format"))
    .min(1, "At least one recipient is required")
    .required("Recipient is required"),
  sender_email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  subject: yup.string().required("Subject is required"),
  content: yup.string().required("Message is required"),
});

const AddSmsCampaign = yup.object().shape({
  name: yup.string().required("Campaign name is required"),
  recipient: yup
    .array()
    .of(
      yup
        .string()
        .required("Phone number is required")
        .matches(/^[+0-9]+$/, "Invalid phone number")
    )
    .min(1, "At least one recipient is required"),

  sender_name: yup.string().required("Sender is required"),
  content: yup.string().required("Message is required"),
});

const AddSmsGroupForm = yup.object().shape({
  name: yup.string().required("Name is required"),
  recipient: yup
    .string()
    .test("is-valid-phone", "Invalid phone number", (value) => {
      if (!value) return false;
      try {
        return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(value));
      } catch (error) {
        return false;
      }
    })
    .required("Phone number is required"),
});

export {
  createTicketValidationForm,
  orderRemarksValidationForm,
  AddContactForm,
  AddContactGroupForm,
  QuickEmailForm,
  QuickSmsForm,
  AddEmailCampaign,
  AddSmsCampaign,
  AddSmsGroupForm,
};
